import i18n from "../../locales/index"
/* eslint-disable */
import { genBasicStore } from "../vuex"

const store = genBasicStore("customer_level")

export default store
